angular.module('tgaAdmin').directive('lottie', [
  '$log',
  '$window',
  function ($log, $window) {
    const controller = [
      '$scope',
      '$element',
      function ($scope, $element) {
        this.initialize = () => {
          if (angular.isDefined($scope.loop)) {
            // eslint-disable-next-line no-restricted-globals
            const isNumeric = !isNaN($scope.loop)
              && !Number.isNaN(parseInt($scope.loop, 10));
            if (isNumeric) {
              $scope.loop = parseInt($scope.loop, 10);
            } else {
              $scope.loop = $scope.loop === 'true';
            }
          }

          const anim = lottie.loadAnimation({
            container: $element[0].childNodes[0],
            renderer: 'svg',
            loop: $scope.loop ? $scope.loop : false,
            autoplay: $scope.autoplay === 'true',
            path: $scope.path,
          });

          $element.on('mouseenter', () => {
            anim.play();
          });

          if ($scope.enterFrame) {
            anim.addEventListener('enterFrame', (info) => {
              $scope.enterFrame(info);
            });
          }

          anim.addEventListener('complete', () => {
            $scope.$emit(`${$scope.name}-lottie-complete`);
            anim.stop();

            if ($scope.completeEvent) {
              $scope.completeEvent();
            }
          });

          $scope.$on(`${$scope.name}-lottie-play`, () => {
            anim.play();
          });

          $scope.$on(`${$scope.name}-lottie-pause`, () => {
            anim.pause();
          });

          $scope.$on(`${$scope.name}-lottie-stop`, () => {
            anim.stop();
          });

          $scope.$on('$destroy', () => {
            anim.destroy();
          });

          $scope.$emit(`${$scope.name}-lottie-ready`);
        };
      },
    ];
    return {
      controller,
      link: (scope, element, attrs, c) => {
        element.ready(() => {
          if (angular.isDefined($window.lottie)) {
            c.initialize();
          } else {
            $log.error(
              "lottie-web needs to be loaded. check your project's gulpfile",
            );
          }
        });
      },
      restrict: 'E',
      template: '<div id="{{name}}-anim"></div>',
      scope: {
        name: '@',
        loop: '@',
        autoplay: '@',
        path: '@',
        enterFrame: '<',
        completeEvent: '<',
      },
    };
  },
]);
